import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Fivezeroseaterbusonrentindaund() {



  const cardData =
  {
    keyword: '50 Seater Bus on Rent in Daund',
    heading: 'Sanavi Travels: 50 Seater Bus on Rent in Daund',
    headingDescription: 'Sanavi Travels offers reliable 50 Seater Bus on Rent in Daund, providing safe, comfortable, and spacious transportation for very large groups, corporate trips, school excursions, family outings, and pilgrimage travel. Our fleet of well-maintained AC and non-AC 50-seater buses ensures ample seating, smooth rides, and sufficient luggage space for a hassle-free journey. With professional drivers, flexible one-way and round-trip rental packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free service. We provide convenient pickup and drop services across Daund, Pune, and nearby areas, making it ideal for local travel, outstation trips, corporate events, and group tours. Choose Sanavi Travels for trusted 50 seater bus rental services in Daund, delivering comfort, safety, and a seamless travel experience for every occasion.',

    top: 'Top Places to Visit in Daund with Sanavi Travels',


"topPlaces": [
  {
    "title": "Bhigwan Bird Sanctuary",
    "description": "Located near Daund, Bhigwan Bird Sanctuary is a haven for bird watchers and nature enthusiasts. Often referred to as the 'Bharatpur of Maharashtra,' it attracts migratory birds such as flamingos, pelicans, storks, and herons, especially during the winter months. Boat rides and early morning visits provide the best wildlife viewing experience."
  },
  {
    "title": "Ujani Dam Backwaters",
    "description": "The backwaters of Ujani Dam near Daund offer a tranquil landscape with expansive water views and surrounding greenery. It is ideal for peaceful outings, photography, and birdwatching, especially at sunrise and sunset."
  },
  {
    "title": "Shri Siddheshwar Temple",
    "description": "Shri Siddheshwar Temple is a local religious site in Daund attracting devotees year-round. The temple is known for its serene spiritual ambiance and traditional ceremonies, making it an important center of devotion in the region."
  },
  {
    "title": "Daund Railway Junction",
    "description": "Daund Railway Junction is a key railway hub in Maharashtra, connecting important routes toward Pune, Solapur, and southern India. Its strategic location makes it significant for travel and trade in the region."
  },
  {
    "title": "Bhigwan Wetlands",
    "description": "The wetlands around Bhigwan near Daund support rich biodiversity and are home to migratory and resident bird species. Nature walks and boat safaris offer immersive experiences in the rural ecosystem."
  },
  {
    "title": "Local Sugarcane Fields",
    "description": "Daund is surrounded by fertile agricultural lands with sugarcane, grains, and vegetables. Visitors can experience rural farming practices and see Maharashtra’s agricultural lifestyle up close."
  },
  {
    "title": "Village Temples and Wadis",
    "description": "Traditional village temples and wadi shrines around Daund reflect the cultural and religious heritage of the area. These sites are often focal points for local festivals and community gatherings."
  },
  {
    "title": "Indapur Road Countryside",
    "description": "The countryside along Indapur Road near Daund features scenic farmland, open fields, and rural landscapes, perfect for leisurely drives, photography, and experiencing peaceful rural life."
  },
  {
    "title": "Weekly Local Markets",
    "description": "Weekly markets in Daund are vibrant spaces where locals sell fresh produce, grains, household items, and livestock. These markets provide insight into local commerce and traditional rural life."
  },
  {
    "title": "Pilgrimage Transit Point",
    "description": "Daund is strategically located near several religious destinations like Pandharpur and Bhigwan, making it a convenient transit point for pilgrims traveling to major temples and spiritual sites."
  }
]
,



"services": [
  {
    "name": "50 Seater Bus on Rent in Daund",
    "description": "50 Seater Bus on Rent in Daund provides a spacious and comfortable travel solution for large groups traveling for weddings, corporate events, family trips, school excursions, or group tours. Equipped with air-conditioning, ergonomic seating, ample luggage space, and professional chauffeurs, this bus ensures safety, comfort, and punctuality. Ideal for both local and outstation trips, it offers a smooth and hassle-free travel experience for all passengers, along with modern amenities for long journeys and group travel convenience."
  },
  {
    "name": "50 Seater Bus Hire Daund",
    "description": "50 Seater Bus Hire Daund offers flexible and affordable bus rental options for group travel, including weddings, corporate outings, religious tours, school trips, and sightseeing. With air-conditioned interiors, spacious seating, and experienced chauffeurs, this service ensures safe, timely, and comfortable transportation for large groups, making travel stress-free and enjoyable."
  },
  {
    "name": "AC 50 Seater Bus Daund",
    "description": "AC 50 Seater Bus Daund provides a cool and comfortable travel experience for large groups traveling for weddings, corporate events, school trips, or outstation journeys. With air-conditioned interiors, comfortable seating, and professional drivers, it ensures smooth, relaxing, and safe travel regardless of distance or weather."
  },
  {
    "name": "Luxury Bus Daund",
    "description": "Luxury Bus Daund delivers premium travel for large groups seeking comfort, style, and convenience. With plush AC seating, spacious interiors, and professional chauffeurs, it is perfect for VIP guests, weddings, corporate events, and special occasions, ensuring timely arrivals, a smooth journey, and a memorable travel experience."
  },
  {
    "name": "Wedding Bus Daund",
    "description": "Wedding Bus Daund specializes in transporting wedding guests safely and comfortably. Air-conditioned interiors, spacious seating, and experienced chauffeurs guarantee punctual travel for family, friends, and guests attending weddings, receptions, and pre- or post-wedding functions, making large group travel organized and hassle-free."
  },
  {
    "name": "Corporate Bus Daund",
    "description": "Corporate Bus Daund offers reliable transportation for employees, corporate events, business meetings, and conferences. Equipped with AC interiors, ample seating, and professional chauffeurs, it ensures safe, comfortable, and timely travel for corporate groups, enhancing convenience and efficiency."
  },
  {
    "name": "Outstation Bus Daund",
    "description": "Outstation Bus Daund caters to large groups traveling to nearby cities, tourist destinations, or religious sites. With air-conditioned interiors, comfortable seating, and skilled drivers, it provides safe, smooth, and enjoyable journeys for families, friends, and corporate travelers alike."
  },
  {
    "name": "Affordable Bus Daund",
    "description": "Affordable Bus Daund provides cost-effective transportation solutions for group travel without compromising on comfort or safety. AC interiors, spacious seating, and professional chauffeurs make it ideal for weddings, corporate trips, sightseeing tours, school excursions, and other group events."
  },
  {
    "name": "Chauffeur Driven Bus Daund",
    "description": "Chauffeur Driven Bus Daund offers a stress-free travel experience with experienced drivers handling navigation, traffic, and passenger safety. Perfect for weddings, corporate events, school trips, and outstation tours, it ensures smooth, reliable, and comfortable journeys for all passengers."
  },
  {
    "name": "Best 50 Seater Bus Daund",
    "description": "Best 50 Seater Bus Daund provides premium and dependable transportation for large groups, families, corporate clients, and tourists. With spacious AC interiors, well-maintained seating, and professional chauffeurs, it guarantees safe, comfortable, and punctual travel for weddings, outstation trips, corporate events, school excursions, and other group travel needs."
  },
  {
    "name": "Tourist Bus Daund",
    "description": "Tourist Bus Daund is perfect for sightseeing trips, leisure travel, religious tours, and excursions. Air-conditioned interiors, professional chauffeurs, and reliable service ensure safe, smooth, and enjoyable journeys to tourist destinations, temples, hill stations, and other attractions."
  },
  {
    "name": "Group Travel Bus Daund",
    "description": "Group Travel Bus Daund caters to families, friends, corporate teams, and school groups traveling together. Spacious seating, AC interiors, and experienced chauffeurs provide organized, safe, and enjoyable travel for weddings, corporate events, school trips, outstation tours, and social gatherings."
  },
  {
    "name": "Event Bus Daund",
    "description": "Event Bus Daund offers reliable transportation for weddings, corporate events, school functions, family gatherings, and social events. Air-conditioned interiors, professional chauffeurs, and timely service ensure comfort, convenience, and a stress-free travel experience for all passengers attending events."
  },
  {
    "name": "Online Bus Booking Daund",
    "description": "Online Bus Booking Daund allows customers to easily reserve 50-seater buses for weddings, corporate trips, group tours, school excursions, and leisure travel. Instant booking confirmation, flexible scheduling, and convenient online management simplify travel planning and ensure a smooth, hassle-free experience for all passengers."
  },
  {
    "name": "Daund Travel Bus",
    "description": "Daund Travel Bus provides safe, comfortable, and reliable transportation for large groups, families, corporate teams, and tourists. Equipped with air-conditioned interiors, spacious seating, and professional chauffeurs, it ensures smooth, enjoyable, and stress-free journeys for weddings, outstation trips, corporate events, school excursions, and social gatherings."
  }
],
"tableData": [
  ["50 Seater Bus on Rent in Daund", "50 Seater Bus Hire Daund"],
  ["AC 50 Seater Bus Daund", "Luxury Bus Daund"],
  ["Wedding Bus Daund", "Corporate Bus Daund"],
  ["Outstation Bus Daund", "Affordable Bus Daund"],
  ["Chauffeur Driven Bus Daund", "Best 50 Seater Bus Daund"],
  ["Tourist Bus Daund", "Group Travel Bus Daund"],
  ["Event Bus Daund", "Online Bus Booking Daund"],
  ["Daund Travel Bus", "—"]
]
,




"whychoose": [
  {
    "WhyChooseheading": "50 Seater Bus on Rent in Daund with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers 50‑seater buses on rent in Daund, perfect for large group travel, corporate outings, school trips, family excursions, and local tours."
  },
  {
    "WhyChooseheading": "Spacious and Well‑Maintained Buses",
    "WhyChoosedescription": "Travel in air‑conditioned, clean, and regularly serviced 50‑seater buses that ensure a comfortable and enjoyable journey in and around Daund."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, punctual, and familiar with local and intercity routes, providing safe and timely transportation for your group."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for 50‑seater bus rentals in Daund, inclusive of fuel, tolls, and driver allowances with no hidden costs."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, route planning, and any last‑minute changes for your 50‑seater bus rental."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, half‑day, full‑day, or customized rental packages based on your travel schedule and group requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All 50‑seater buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for 50‑seater bus rentals in Daund."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide 50‑seater buses on rent in Daund?',
    answer: 'Yes, Sanavi Travels offers 50‑seater bus rentals in Daund for large group travel, corporate events, and local tours.'
  },
  {
    question: 'How can I book a 50‑seater bus in Daund?',
    answer: 'You can easily book through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'Are the 50‑seater buses well‑maintained and air‑conditioned?',
    answer: 'Yes, all our 50‑seater buses are clean, air‑conditioned, and regularly serviced for a comfortable travel experience.'
  },
  {
    question: 'Are drivers experienced with Daund and nearby routes?',
    answer: 'Yes, our drivers are professional, licensed, and familiar with both local and intercity routes to ensure safe and timely transportation.'
  },
  {
    question: 'Can I rent the 50‑seater bus for a few hours or a full day?',
    answer: 'Absolutely. We offer hourly, half‑day, full‑day, and customized rental packages to meet your travel needs.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all 50‑seater buses are thoroughly cleaned and sanitized before departure.'
  },
  {
    question: 'Is customer support available during the rental?',
    answer: 'Yes, our 24x7 customer support team is available throughout your 50‑seater bus rental.'
  },
  {
    question: 'What payment options are available for 50‑seater bus rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is punctual service guaranteed for 50‑seater bus rentals?',
    answer: 'Yes, Sanavi Travels ensures on‑time pickups and reliable service for all 50‑seater bus bookings in Daund.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ramesh Kulkarni',
    feedback: 'Booked a 50‑seater bus in Daund for our corporate trip. Comfortable and spacious with excellent service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Sneha Patil',
    feedback: 'Excellent 50‑seater bus rental experience! Smooth ride, clean bus, and very supportive staff.',
    rating: 5
  }
];


























































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "50 Seater Bus on Rent in Daund - Sanavi Travels",
  "description": "Sanavi Travels offers 50 Seater bus rental in Daund for weddings, corporate events, outstation trips, family outings, and group travel. AC and luxury chauffeur-driven buses are available with easy online booking.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "90"
  }
};






  return (
    <div>
<Helmet>
  <title>
    50 Seater Bus on Rent in Daund | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book a 50 Seater bus in Daund with Sanavi Travels for weddings, corporate events, outstation trips, family outings, and group travel. AC and luxury chauffeur-driven buses available with online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/110.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Fivezeroseaterbusonrentindaund;